module.exports = __webpack_public_path__ + "static/media/Inductor.43b96833.svg";